var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFitness = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Fitness-Six-Pack--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Fitness Six Pack Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14 14.5a1 1 0 0 1 -1 -1 1 1 0 0 0 -2 0 1 1 0 0 1 -1 1 1 1 0 0 0 0 2 3 3 0 0 0 1.71 -0.5 0.51 0.51 0 0 1 0.58 0 3 3 0 0 0 1.71 0.5 1 1 0 0 0 0 -2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 20a1 1 0 0 1 -1 -1 1 1 0 0 0 -2 0 1 1 0 0 1 -1 1 1 1 0 0 0 0 2 3 3 0 0 0 1.71 -0.54 0.51 0.51 0 0 1 0.58 0A3 3 0 0 0 14 22a1 1 0 0 0 0 -2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 11a1 1 0 0 0 -1 -1 3 3 0 0 0 -3 3v10a1 1 0 0 0 2 0V13a1 1 0 0 1 1 -1 1 1 0 0 0 1 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10a1 1 0 0 0 0 2 1 1 0 0 1 1 1v10a1 1 0 0 0 2 0V13a3 3 0 0 0 -3 -3Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.56 10.54a1 1 0 0 0 -1.77 0.93l1.6 3.06a1 1 0 0 1 0.11 0.47v8a1 1 0 0 0 2 0v-8.5a1 1 0 0 0 -0.11 -0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.79 10.12a1 1 0 0 0 -1.35 0.42L19.61 14a1 1 0 0 0 -0.11 0.46V23a1 1 0 0 0 2 0v-8a1 1 0 0 1 0.11 -0.46l1.6 -3.06a1 1 0 0 0 -0.42 -1.36Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 0a1 1 0 0 0 -1 1v2c0 2.37 -2.83 3 -4.5 3S13 5.37 13 3a1 1 0 0 0 -2 0c0 2.37 -2.83 3 -4.5 3S2 5.37 2 3V1a1 1 0 0 0 -2 0v2c0 3.45 3.26 5 6.5 5a7.5 7.5 0 0 0 5.15 -1.76 0.52 0.52 0 0 1 0.7 0A7.5 7.5 0 0 0 17.5 8C20.74 8 24 6.45 24 3V1a1 1 0 0 0 -1 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFitness);
export default ForwardRef;